import { ICON_PATHS } from "../icons/icons.generated";

/** Materialized SVG paths from the catalog; persisted keys never become SVG markup. */
export const CategoryIcon = ({ name, size = 22 }: { name?: string | null; size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" dangerouslySetInnerHTML={{ __html: ICON_PATHS[name ?? "tag"] ?? ICON_PATHS.tag }} />
);
